export enum UserSort {
  OIB = 1,
  LastName = 2,
  FirstName = 3,
}
